module.exports = __webpack_public_path__ + "media/about/SalvationArmy-ec5a2156.jpg";